import Breadcrumb from "../../../components/admin/layouts/Breadcrumb/Breadcrumb";
import Container from "../../../components/admin/layouts/Container/Container";
import Header, { HeaderLeft, HeaderRight } from "../../../components/admin/layouts/Header/Header";
import PageWrapper from "../../../components/admin/layouts/PageWrapper/PageWrapper";
import Subheader, { SubheaderLeft, SubheaderRight } from "../../../components/admin/layouts/Subheader/Subheader";
import Card from "../../../components/ui/Card";
import TablePartial from "./_partial/Table.partial";
import CompanyImg from "../../../assets/png/company.png";
import DefaultHeaderRightCommon from "../../../templates/layouts/Headers/_common/DefaultHeaderRight.common";
import AddMachineModel from "../../../components/admin/home/addMachineModel";
import { useEffect, useState } from "react";
import { GetPagedAssets, postMachinesList } from "../../../services/FeaturedListings";
import { ApplicationId } from "../../../api/url";
import { logoutFun } from "../../../utils/helper";
// import { useMsal } from "@azure/msal-react"; // Azure B2C - temporarily disabled
import { getCompanyById } from "../../../services/companyService";
import getFirstLetter from "../../../utils/getFirstLetter";
import classNames from "classnames";
import useRoundedSize from "../../../hooks/useRoundedSize";
import { GetPictureByContext } from "../../../services/vizyBilityServices";
import AddCompany from "./addCompany";

const CompanyInfo = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [machineData, setMachineData] = useState([
    {
      SubscriptionCode: "Full01",
      Description: "Unlimited Pacakage",
      StartDate: "2024-03-05",
      EndDate: "2025-03-04",
      MonthlyCosts: "$499",
    },
    {
      SubscriptionCode: "Con05",
      Description: "Consignment Service",
      StartDate: "2024-03-05",
      EndDate: "2025-03-04",
      MonthlyCosts: "$499",
    },
    {
      SubscriptionCode: "Con05",
      Description: "Consignment Service",
      StartDate: "2024-03-05",
      EndDate: "2025-03-04",
      MonthlyCosts: "$499",
    },
  ]);
  const [pagination, setPagination] = useState({
    currectPage: 1,
    showRecords: 5,
    totalRecords: 10,
    pageCount: 1,
  });
  const [refresh, setRefresh] = useState(true);
  // const { instance, accounts } = useMsal(); // Azure B2C - temporarily disabled
  const { roundedCustom } = useRoundedSize("rounded-xl");
  const [companyInfo, setCompanyInfo] = useState({});
  const [companyImg, setCompanyImg] = useState({});
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  useEffect(() => {
    GetCompanyInfo();
    GetCompanyImg();
  }, []);

  const GetCompanyInfo = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getCompanyById(azureUserInfo?.CompanyId, header)
      .then((res) => {
        setCompanyInfo(res.data);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };

  const GetCompanyImg = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const query = `context=Company&contextId=${azureUserInfo?.CompanyId}`;

    GetPictureByContext(query, header)
      .then((res) => {
        setCompanyImg(res.data);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun();
        }
      });
  };

  const refreshPage = () => {
    GetCompanyInfo();
    GetCompanyImg();
  };

  const handleResetPagination = () => {
    setPagination({
      ...pagination,
      currectPage: 1,
    });
    setRefresh(!refresh);
  };

  const setPageSize = (showRecords) => {
    setPagination({
      ...pagination,
      currectPage: 1,
      showRecords,
    });
  };

  const setPageIndex = (Index) => {
    setPagination({
      ...pagination,
      currectPage: Index,
    });
  };
  return (
    <>
      <Header>
        <HeaderLeft>
          <Breadcrumb path="Paving Market / Company Info" currentPage="Company" />
        </HeaderLeft>
        <HeaderRight>
          <DefaultHeaderRightCommon />
        </HeaderRight>
      </Header>

      <PageWrapper name="Company Info">
        <Subheader>
          <SubheaderLeft>
            <div className="flex items-center">
              <div className="mr-[10px]">
                {companyImg?.[0]?.url ? (
                  <img src={companyImg?.[0]?.url} alt="" className="h-12 w-12" />
                ) : (
                  <div
                    className={classNames(
                      "flex aspect-square h-12 w-12 items-center justify-center bg-blue-500/20 text-blue-500",
                      [`${roundedCustom(-2)}`]
                    )}
                  >
                    {companyInfo?.CompanyName && getFirstLetter(companyInfo?.CompanyName)}
                  </div>
                )}
              </div>
              <div>
                <div className="text-lg font-semibold">{companyInfo?.CompanyName}</div>
                <div className="text-sm text-zinc-500">
                  {companyInfo?.Address1} {companyInfo?.Address2}
                </div>
              </div>
            </div>
          </SubheaderLeft>
        </Subheader>

        <Container>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12">
              <AddCompany companyInfo={companyInfo} companyImg={companyImg} refreshPage={refreshPage} />
            </div>
          </div>
        </Container>
        {/* <Container>
          <Container>
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12">
                <Card className="h-full">
                  <TablePartial
                    isLoading={isLoading}
                    machineData={machineData}
                    pagination={pagination}
                    setPageSize={setPageSize}
                    setPageIndex={setPageIndex}
                    handleResetPagination={handleResetPagination}
                  />
                </Card>
              </div>
            </div>
          </Container>
        </Container> */}
      </PageWrapper>
    </>
  );
};
export default CompanyInfo;
